import { Component, ViewEncapsulation, Inject, ElementRef } from '@angular/core';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { StocksExchangeWalletAction } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.action';

@Component({
  selector: 'dialog-success-wrap',
  templateUrl: './dialog-success-wrap.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DialogSuccessWrapComponent extends DialogFullScreenComponentContent {

  constructor(
    protected element: ElementRef,
    private dialogReference : MatDialogRef<DialogSuccessWrapComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private store: Store<AppState>
  ) {
    super(element)
  }

  public dispose(event: Event) {
    super.close(this.dialogReference, null);
    this.store.dispatch({ type: StocksExchangeWalletAction.getInvestments });
    event.preventDefault();
  }

}